import { AssetType } from "@zapier/canvas-state";
import capitalizeFirstLetter from "./capitalizeFirstLetter";

export function getAssetStepTitlePlaceholderText(assetType: AssetType) {
  if (assetType) {
    return `Describe your ${capitalizeFirstLetter(assetType)}`;
  }

  return "Describe what happens in this step";
}
